const styles = (theme) => ({
  login: {
    padding: theme.spacing(12, 6),
    maxWidth: 500,
    margin: '0 auto',
  },
});

export default styles;
